var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail__list"},_vm._l((_vm.entries),function(entry){return _c('div',{staticClass:"detail__entry"},[_c('span',[_vm._v(_vm._s(entry))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }